import { MutationTree } from "vuex";
import { VideoReportingState, VideoReportingStates, DeviceEventRecords } from "./types";
import { getDefaultState } from "./state";

export const mutations: MutationTree<VideoReportingState> = {
	setVideoReportingPrefs(state, prefs: any) {
		state.videoReportingPrefs = prefs;
	},
	setVideoReportingState(state, newState: VideoReportingStates) {
		state.videoReportingState = newState;
	},
	setCurrentReportEventId(state, eventId: number) {
		state.currentReport.eventId = eventId;
	},
	setCurrentReportId(state, videoReportId: number) {
		state.currentReport.videoReportId = videoReportId;
	},
	reviewComplete(state) {
		state.currentReport.reviewsComplete++;
	},
	cameraComplete(state) {
		state.currentReport.camerasComplete++;
	},
	setAuditEndpoint(state, auditEndpoint: string) {
		state.auditEndpoint = auditEndpoint;
	},
	setDeviceEventRecords(state, deviceEventRecords: DeviceEventRecords) {
		state.deviceEventRecords = deviceEventRecords;
	},
	resetState(state) {
		Object.assign(state, getDefaultState());
	}
};
